module.exports = __webpack_public_path__ + "static/img/no_image.d455ba7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/no_image.svg
// module id = uXCq
// module chunks = 3